import { RouteObject } from 'react-router-dom';
import { routeDirectory } from 'modules';

import { AllTier1ReturnAuthorizationsActivity } from 'activities/admin/AllTier1ReturnAuthorizationsActivity/AllTier1ReturnAuthorizationsActivity';
import { AppleCareAgreementsActivity } from './AppleCareAgreementsActivity/AppleCareAgreementsActivity';
import { AppSettingsActivity } from './AppSettingsActivity/AppSettingsActivity';
import { CustomersActivity } from 'activities/admin/CustomersActivity/CustomersActivity';
import { DataCacheActivity } from './DataCacheActivity/DataCacheActivity';
import { DebugActivity } from './DebugActivity/DebugActivity';
import { InventoryActivity } from './InventoryActivity/InventoryActivity';
import { NetSuiteActivity } from './NetSuiteActivity/NetSuiteActivity';
import { OrderManagementActivity } from './OrderManagementActivity/OrderManagementActivity';
import { OrderDetailActivity } from './OrderDetailActivity/OrderDetailActivity';
import { ReconciliationReportActivity } from './ReconciliationReportActivity/ReconciliationReportActivity';
import { ReturnAuthorizationsActivity } from './ReturnAuthorizationsActivity/ReturnAuthorizationsActivity';
import { ReturnAuthorizationDetailActivity } from 'activities/admin/ReturnAuthorizationDetailActivity/ReturnAuthorizationDetailActivity';
import { ReturnAuthorizationsActivityDeprecated } from './ReturnAuthorizationsActivity_Deprecated/ReturnAuthorizationsActivity';
import { RootAdminActivity } from './RootAdminActivity/RootAdminActivity';
import { SalesOrdersActivity } from 'activities/admin/SalesOrdersActivity/SalesOrdersActivity';
import { StoreSettingsActivity } from './StoreSettingsActivity/StoreSettingsActivity';
import { ThirdPartyAccountActivity } from './ThirdPartyAccountActivity/ThirdPartyAccountActivity';
import { ThirdPartyLogisticsActivity } from './ThirdPartyLogisticsActivity/ThirdPartyLogisticsActivity';
import { ValidateOrderActivity } from './ValidateOrderActivity/ValidateOrderActivity';
import { Tier1ReturnAuthorizationsActivity } from './Tier1ReturnAuthorizationsActivity/Tier1ReturnAuthorizationsActivity';
import { Tier1ReturnAuthorizationDetailActivity } from './Tier1ReturnAuthorizationDetailActivity/Tier1ReturnAuthorizationDetailActivity';



export const routes: RouteObject[] = [
  {
    path: routeDirectory.admin.root.raw,
    element: <RootAdminActivity />
  },
  {
    path: routeDirectory.admin.appleCareAgreements.raw,
    element: <AppleCareAgreementsActivity />
  },
  {
    path: routeDirectory.admin.appSettings.raw,
    element: <AppSettingsActivity />
  },
  {
    path: routeDirectory.admin.customers.raw,
    element: <CustomersActivity />
  },
  {
    path: routeDirectory.admin.dataCache.raw,
    element: <DataCacheActivity />
  },
  {
    path: routeDirectory.admin.netSuite.raw,
    element: <NetSuiteActivity />
  },
  {
    path: routeDirectory.admin.orderManagement.raw,
    element: <OrderManagementActivity />
  },
  {
    path: routeDirectory.admin.validateOrder.raw,
    element: <ValidateOrderActivity />
  },
  {
    path: routeDirectory.admin.inventory.raw,
    element: <InventoryActivity />
  },
  {
    path: routeDirectory.admin.storeDetail.raw,
    element: <StoreSettingsActivity />
  },
  {
    path: routeDirectory.admin.orderDetail.raw,
    element: <OrderDetailActivity />
  },
  {
    path: routeDirectory.admin.orders.raw,
    element: <SalesOrdersActivity />
  },
  {
    path: routeDirectory.admin.reconciliationReport.raw,
    element: <ReconciliationReportActivity />
  },
  {
    path: routeDirectory.admin.returnAuthorizations.list.raw,
    element: <ReturnAuthorizationsActivity />
  },
  {
    path: routeDirectory.admin.returnAuthorizations.detail.raw,
    element: <ReturnAuthorizationDetailActivity />
  },
  {
    path: routeDirectory.admin.returnAuthorizations_deprecated.raw,
    element: <ReturnAuthorizationsActivityDeprecated />
  },
  {
    path: routeDirectory.admin.thirdPartyLogistics.raw,
    element: <ThirdPartyLogisticsActivity />
  },
  {
    path: routeDirectory.admin.debug.raw,
    element: <DebugActivity />
  },
  {
    path: routeDirectory.admin.thirdPartyAccounts.raw,
    element: <ThirdPartyAccountActivity />
  },
  {
    path: routeDirectory.admin.tier1ReturnAuthorizations.list.raw,
    element: <Tier1ReturnAuthorizationsActivity />
  },
  {
    path: routeDirectory.admin.tier1ReturnAuthorizations.detail.raw,
    element: <Tier1ReturnAuthorizationDetailActivity />
  },
  {
    path: routeDirectory.admin.tier1ReturnAuthorizations.all.raw,
    element: <AllTier1ReturnAuthorizationsActivity />
  }
];
